const MenuIcon = ({
  toggle,
  toggled,
  firstIcon: ComponentOne,
  secondIcon: ComponentTwo,
}) => {
  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        toggle(!toggled);
      }}
      type="button"
    >
      {toggled
        ? // <X size={20} className="menu-icon" />
          ComponentOne
        : // <Ellipsis className="menu-icon" size={20} />
          ComponentTwo}
    </button>
  );
};

export default MenuIcon;
